;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import Link from 'next/link';

export function DontHaveAnAccountYet() {
  return (
    <div>
      <span className="text-sm leading-none font-normal text-neutral-200 dark:text-neutral-100">
        Are you an employer without an account?{' '}
      </span>
      <span className="text-sm leading-none font-bold text-neutral-200 dark:text-neutral-100">
        <Link href={`${process.env.NEXT_PUBLIC_FE_URL_EOR}/sign-up`}>Sign up</Link>
      </span>
    </div>
  );
}
